import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findAll ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`SubjectAssessmentDM/findAll`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  list ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`SubjectAssessmentDM/list`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findAllSchool ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`SubjectAssessmentDM/findAllSchool`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getTreeData ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`SubjectAssessmentDM/getTreeData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findById ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`SubjectAssessmentDM/findById`, { params })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deleteById ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`SubjectAssessmentDM/deleteById`, { params })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  templateImport ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`SubjectAssessmentDM/templateImport`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  saveSubjectAsses ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`SubjectAssessmentDM/saveSubjectAsses`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  templateUpload ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/SubjectAssessmentDM/templateUpload',
        params: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },






}
